import layerInfo from "./util/layer-info";
import selectBox from "./util/selectbox";
import selectInfo from "./util/select-info";

let layer = {}, select = {};
$.each(layerInfo, function(index, value){
    layer[value.name] = promokit.layer({
        el:value.el,
        buttons:value.btn,
        render:value.render
    });
});
$.each(selectInfo, function(index, value){
    select[value.name] = new selectBox({
        el:value.el,
        scHeight:179
    });
});

$(document).on('click', '.cases__btn--login', function(){
    promokit.login();
});

$(".p-btn__buy, .p-btn__box").attr("href", "https://lineagenshop.plaync.com/lineage/goods/detail?dgi=412087");

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        home:true,
        event:true,
        sns:true,
        theme:'black'
    },
    caution:{
        template:
            `<ol>
                <li>제재된 계정은 이벤트 참여가 불가합니다.</li>
                <li>본 이벤트는 테스트 서버에서는 진행할 수 없습니다.</li>
                <li>클래스 체인지는 계정당 1회만 가능하며 체인지 이후로는 원상 복구가 불가능합니다.</li>
                <li>클래스 체인지 적용 시점에 신청 캐릭터가 삭제 대기 상태인 경우, 신청이 취소됩니다.</li>
                <li>클래스 체인지 결과 확인 시 출력되는 경험치는 소수점 셋째 자리에서 반올림한 경험치입니다.</li>
                <li>마지막 주차인 2021. 10. 27.(수) 정기점검 전에 신청된 내역은 2021. 10. 27.(수) 정기점검 시 반영됩니다.</li>
                <li>클래스 체인지에 사용된 주 캐릭터의 기존 경험치는 모두 손실됩니다.</li>
                <li>‘전사 클래스 체인지 상자’ 아이템은 2021. 10. 27.(수) 정기점검 시 삭제됩니다.</li>
                <li>‘전사의 증표‘ 및 ‘전사의 스킬 증표(데몰리션/타이탄: 비스트)’ 아이템은 2021. 11. 3.(수) 정기점검 시 삭제됩니다.</li>
                <li>주 캐릭터에 지급되는 ‘영웅의 스킬 용해제’ 및 ‘회상의 촛불’ 아이템은 2021. 11. 3.(수) 정기점검 시 자동 삭제됩니다.</li>
        </ol>`
}
});


// WEBPACK FOOTER //
// ./src/js/index.js